export default {
  // 搜索
  search: {
    title: '搜索',
    resultsFor: '搜索结果',
    noResults: '未找到相关内容',
    startSearching: '开始搜索',
  },

  // 首页
  home: {
    welcomeBack: '欢迎回来',
    discoverTravel: '探索旅行',
    discoverPlans: '发现精彩的旅行计划',
    whereToGo: '想去哪里玩?',
    viewMore: '查看更多',
    recommendedCards: '推荐卡片',
    latestPosts: '最新游记',
    loginPrompt: '登录以创建和管理您的行程',
    loginButton: '登录/注册',
  },

  // 卡片列表
  cardList: {
    title: '卡片浏览',
    searchPlaceholder: '搜索卡片...',
    types: {
      poi: '景点',
      restaurant: '餐厅',
      lodging: '住宿',
      activity: '活动',
      shopping: '购物',
    },
    filters: {
      tags: '标签',
      category: '分类',
      subcategory: '子分类',
      location: '地区',
      clear: '清除',
    },
    status: {
      loading: '加载中...',
      switchingPages: '正在切换页面...',
      noMore: '没有更多卡片了',
      emptyTitle: '未找到卡片',
      emptyText: '尝试调整搜索条件或过滤器',
    },
    modal: {
      title: '卡片详情',
      close: '关闭',
      addToItinerary: '加入行程',
    }
  },

  // 卡片详情页
  cardDetail: {
    tabs: {
      book: '预订',
      details: '详细信息',
      nearby: '附近景点',
      description: '描述',
    },
    gallery: {
      allPhotos: '所有图片',
      tripPhotos: '行程图片',
      addPhoto: '添加图片',
    },
    affiliate: {
      bookOn: '在 {{brand}} 上预订',
      searchOn: '在 {{brand}} 上搜索',
    },
  },

  // 模块头部
  header: {
    title: '拼游',
    subtitle: '智能行程推荐，AI收据识别',
  },

  common: {
    close: '关闭',
  },

  // 旅行卡片
  travelCard: {
    status: {
      active: '进行中',
      planning: '计划中',
      completed: '已完成',
      cancelled: '已取消',
    },
    actions: {
      viewDetails: '查看详情',
      joinTravel: '加入拼游',
      editTravel: '编辑拼游',
      enterChat: '进入聊天',
    },
    info: {
      members: '拼客',
      budget: '预算',
      duration: '时长',
      days: '天',
      perPerson: '/ 人',
      noLocation: '未设置地点',
      noBudget: '未设置预算',
      noMembers: '暂无成员',
      memberCount: '{{count}} 名拼客',
      memberCount_plural: '{{count}} 名拼客',
      actualCost: '实际费用',
      public: '公开',
      friendsOnly: '仅限好友',
      private: '私密',
    },
    dates: {
      to: '至',
      startDate: '出发日期',
      endDate: '返回日期',
    },
  },

  // 旅行列表
  travelList: {
    loading: {
      title: '正在加载旅行列表...',
      subtitle: '请稍候',
    },
    empty: {
      title: '暂无拼游',
      subtitle: '点击右上角按钮创建拼游，或点击发现按钮加入其他拼游',
    },
    discover: {
      title: '发现',
    },
    messages: {
      error: '错误',
      fetchListFailed: '获取拼游列表失败',
      unknownError: '未知错误',
      likeFailed: '点赞操作失败',
      likeSuccess: '已点赞',
      unlikeSuccess: '已取消点赞',
    },
  },

  // 创建拼游
  createTravel: {
    // 页面头部
    header: {
      title: '创建拼游',
      subtitle: '填写拼游信息',
    },
    title: '创建拼游',
    // 基本信息
    projectName: '拼游名称',
    projectNamePlaceholder: '为您的拼游命名',
    dateRange: '旅行日期',
    startDate: '出发日期',
    endDate: '返回日期',
    // 目的地
    destination: '目的地',
    selectCountry: '选择国家',
    selectCity: '选择城市',
    customCity: '或输入自定义城市',
    customCityPlaceholder: '输入城市名称（例如：巴黎、东京、纽约）',
    destinationLabel: '目的地：',
    // 旅行偏好
    travelPreferences: '您的旅行偏好',
    preferencesSubtitle: '选择您感兴趣的内容，帮助AI定制行程',
    multiSelect: '（可多选）',
    // 偏好选项
    preferences: {
      culture: '文化',
      food: '美食',
      scenery: '风景',
      history: '历史',
      deepTour: '深度游',
      checkin: '打卡',
    },
    // 项目描述
    projectDescription: '拼游描述',
    projectDescriptionPlaceholder: '介绍此行程的特点和亮点...',
  editItinerary: '编辑行程',
    descriptionPlaceholder: '介绍此行程的特点和亮点...',
    aiGenerate: 'AI智能生成描述',
    aiGenerating: '正在生成...',
  aiGenerateItinerary: 'AI智能生成行程',
  regenerate: '重新生成',
  itineraryPreview: '行程预览',
  itineraryEmptySimple: '点击开始编辑行程',
    // 支付模式
    paymentMode: '支付模式',
    prepayAverage: '预付均分',
    prepayAverageDesc: '提前收取固定金额，平均分配',
    prepayShare: '按份额预付',
    prepayShareDesc: '提前收取固定金额，按份额分配',
    actualAverage: '实际费用（均分）',
    actualAverageDesc: '实际消费后平均分配',
    actualShare: '实际费用（按份额）',
    actualShareDesc: '实际消费后按份额分配',
    // 结算货币
    settlementCurrency: '结算货币',
    selectCurrency: '选择货币',
    // 货币名称
    currencies: {
      CNY: '人民币',
      USD: '美元',
      EUR: '欧元',
      JPY: '日元',
      GBP: '英镑',
      AUD: '澳元',
      CAD: '加元',
      CHF: '瑞士法郎',
      HKD: '港币',
      SGD: '新加坡元',
      KRW: '韩元',
      TWD: '新台币',
      THB: '泰铢',
      MYR: '马来西亚林吉特',
    },
    // 每人预算
    budgetPerPerson: '每人预算',
    budgetPlaceholder: '0',
    budgetUnit: '/ 人',
    budgetHint: '用于预算规划和成员参考的每人预计费用',
    // 项目可见性
    projectVisibility: '项目可见性',
    visibilitySubtitle: '选择谁可以查看和加入您的旅行项目',
    publicProject: '公开项目',
    publicProjectDesc: '所有人都可以查看并申请加入',
    friendsVisible: '好友可见',
    friendsVisibleDesc: '好友可以查看并申请加入',
    privateProject: '私密项目',
    privateProjectDesc: '仅限邀请好友',
    // 背景图片
    backgroundImage: '背景图片',
    selectBackground: '选择背景',
  backgroundPlaceholder: '点击选择背景图片',
  // 兼容旧键
  selectBackgroundPlaceholder: '点击选择背景图片',
    backgroundImages: {
      beach: '海滩度假',
      churches: '教堂建筑',
      airplane: '飞行之旅',
      cruise: '游轮旅行',
      fuji: '富士山',
      germany: '德国风光',
      holland: '荷兰风车',
      hongkong: '香港夜景',
      korea: '韩国风光',
      london: '伦敦印象',
      maldives: '马尔代夫',
      mountain: '山地雪景',
      paris: '巴黎浪漫',
      sakura: '樱花',
      sea: '湛蓝海洋',
      shanghai: '上海风光',
      singapore: '新加坡印象',
      snow: '降雪',
      sunrise: '日出东方',
      sunsets: '日落西方',
      swiss: '瑞士风光',
      thailand: '泰国风情',
      vietnam: '越南印象',
      waterfalls: '飞瀑流泉',
    },
    // 按钮
    createProject: '创建旅行项目',
    next: '创建拼游',
    // 提示消息
    alerts: {
      hint: '提示',
      success: '成功',
      error: '错误',
      enterProjectName: '请输入拼游名称',
      selectDestination: '请选择目的地',
      selectDestinationCity: '请选择目的地城市',
      enterProjectDescription: '请输入项目描述',
      invalidDateRange: '结束日期不能早于开始日期',
      generatedSuccess: 'AI描述生成成功！',
      generateFailed: 'AI生成失败',
      aiGenerationFailed: 'AI生成失败',
      errorDetails: '错误详情',
      createSuccess: '旅行项目创建成功！',
      createSuccessMessage: '您的旅行项目已创建成功，快去邀请好友加入吧！',
      createFailed: '创建失败',
      createFailedMessage: '请检查网络连接后重试',
      createFailedDetail: '如问题持续，请联系客服。',
      userNotLoggedIn: '用户未登录，请先登录',
      unknownError: '未知错误',
      travelCreateFailed: '拼游创建失败',
      viewProject: '查看项目',
      // AI相关提示
      aiDisabledMessage: 'AI智能推荐功能已禁用\nAI行程生成已取消\n您可以在设置中重新启用',
      goToSettings: '前往设置',
    },
    // 警告提示
    warnings: {
      editBeforeCreate: '建议先完成创建操作，再进入行程编辑',
      continueEdit: '继续编辑',
    },
    // AI提示相关
    aiPrompt: {
      role: '您是一位专业旅行规划师。请为以下旅行项目生成详细、吸引人且实用的行程介绍。',
      // 基本信息部分
      basicInfo: '项目基本信息',
      projectNameLabel: '拼游名称',
      destinationLabel: '目的地',
      travelTimeLabel: '旅行时间',
      participantsLabel: '参与者',
      preferencesLabel: '旅行偏好',
      budgetLabel: '每人预算',
      noPreferences: '无特定偏好',
      budgetTbd: '预算待定',
      paymentModeLabel: '支付模式',
      daysCount: '（共{days}天）',
      // 支付模式映射
      paymentModes: {
        prepay_average: '预付均分模式',
        prepay_share: '预付按份模式',
        actual_average: '实际费用均分模式',
        actual_share: '实际费用按份模式',
      },
      // 要求部分
      requirements: '生成要求',
      generateContent: '请生成包含以下内容的行程介绍：',
      contentItems: {
        highlights: '**项目亮点**：基于目的地特点和用户偏好，突出此次旅行的独特之处',
        itinerary: '**详细行程**：按天计划具体的景点、活动和体验',
        food: '**美食推荐**：当地特色美食和餐厅推荐',
        accommodation: '**住宿建议**：适合团队的住宿类型和区域',
        transportation: '**交通指南**：到达目的地的交通方式及当地交通选择',
        budget: '**预算参考**：各类费用的大致预算范围',
        tips: '**实用贴士**：包括天气、签证、必需品及其他实用信息',
        teamActivities: '**团队活动**：适合{min}至{max}人团队的特别活动',
      },
      // 风格要求部分
      styleRequirements: '风格要求',
      styleItems: {
        0: '生动有趣的语言，充满吸引力',
        1: '内容详细具体，注重实用性',
        2: '突出团队合作和社交属性',
        3: '反映团队旅行的经济效益和乐趣',
        4: '使用适当表情符号增加趣味',
        5: '总字数控制在400-500字',
      },
      generateStart: '请开始生成：',
    },
  },

  // 旅行详情页面
  travelDetail: {
    actions: {
      editItinerary: '编辑行程',
      approve: '批准',
      reject: '拒绝',
        settlement: '费用设置',
    },
    loading: {
      title: '正在加载旅行详情...',
      subtitle: '请稍候',
    },
    error: {
      title: '加载失败',
      subtitle: '未找到旅行项目',
      retryButton: '重新加载',
    },
    // 页面内容
    content: {
      projectDescription: '项目描述',
  itineraryOverview: '行程总览',
      todoList: '待办事项',
      members: '拼客',
      add: '添加',
      expand: '展开',
      collapse: '收起',
      expandWithCount: '展开（{{count}} 项）',
  unknownUser: '未知用户',
  creator: '创建者',
  member: '拼客',
  pending: '待审',
  pendingAdd: '待审 - 新增',
  pendingEdit: '待审 - 修改',
  completed: '已完成',
  inviteFriends: '邀请好友',
  recommendFriends: '推荐好友',
      noTodos: '暂无待办事项',
      noTodosSubtext: '点击右上角添加按钮创建待办事项',
    },
    // 弹窗
    modal: {
      paymentSettings: '支付设置',
      paymentMode: '支付模式',
      memberShareSettings: '成员份额设置',
      memberShareDescription: '为每个成员设置份额比例。例如：成人1.0，儿童0.5，情侣2.0',
      totalShares: '总份额',
      averageMode: '均分模式',
      shareMode: '按份模式',
      prepaidMode: '预付模式（旅行社模式，不可退款）',
      actualExpenseMode: '实际费用模式（按实际费用分配）',
      currentProjectUses: '当前项目使用',
    },
    // 消息
    messages: {
      success: '成功',
      error: '错误',
      loadFailed: '加载旅行详情失败',
      unknownError: '未知错误',
      userNotLoggedIn: '用户未登录',
      paymentSettingsSaved: '支付设置已保存',
      saveShareSettingsFailed: '保存份额设置失败',
      addTodoFailed: '添加待办事项失败',
      batchAddTodosFailed: '批量添加待办事项失败',
      todosAdded: '已添加 {{count}} 个待办事项',
      operationFailed: '操作失败',
      likeFailed: '点赞操作失败',
      insufficientPermission: '权限不足',
      needJoinFirst: '您需要先加入项目才能推荐好友',
      onlyCreatorCanInvite: '仅项目创建者可邀请好友加入私密项目',
      savePaymentModeFailed: '保存支付模式失败',
    },
  },

  // 费用设置弹窗
  expenseSettingsModal: {
    // 头部
    title: '费用分摊设置',
    cancel: '取消',
    save: '保存',
    // 权限通知
    permissionNotice: '仅旅行创建者可以修改费用设置',
    // 费用模式
    expenseModeSection: {
      title: '📊 分摊模式',
      subtitle: '选择适合您旅行活动的费用管理方式',
      // 预付模式
      prepaidMode: {
        title: '预付模式',
        subtitle: '成员提前支付，统一费用管理',
        description: '适用于预算明确的旅行活动，如旅游、聚会等。需设置总预算。',
        features: [
          '设置总预算金额',
          '成员按份额比例预付',
          '实时跟踪余额',
          '退款或补交结算',
        ],
      },
      // 实际费用模式
      actualExpenseMode: {
        title: '实际费用模式',
        subtitle: '成员各自支付费用，之后按实际费用分摊',
        description: '适用于费用不确定的旅行活动，如项目合作等，无需预设预算。',
        features: [
          '上传收据',
          '费用审批流程',
          '灵活的类别管理',
          '实际费用分摊',
        ],
      },
    },
    // 份额设置
    shareSection: {
      title: '⚖️ 份额比例',
      subtitle: '选择具体的费用分摊方式',
      toggleTitle: '启用按份分摊',
      // 不同模式描述
      descriptions: {
        prepaidWithShares: '预付后根据实际消费退款或补交，考虑个人差异',
        prepaidWithoutShares: '类似旅行团模式，创建者统一安排，平均分摊',
        actualExpenseWithShares: '按成员份额比例分摊实际费用',
        actualExpenseWithoutShares: '所有费用平均分摊，不考虑个人差异',
      },
      // 按份分摊示例
      shareExamples: {
        title: '💡 按份分摊说明',
        prepaidMode: '预付模式 + 按份分摊：\n• 成员按份额比例预付不同金额\n• 活动后根据实际消费重新计算\n• 反映个人差异，退款或补交\n• 适用场景：家庭旅行、朋友聚会',
        actualExpenseMode: '实际费用 + 按份分摊：\n• 成员各自支付，上传收据\n• 按份额比例分摊总费用\n• 最终统一结算差额\n• 适用场景：项目合作、AA制聚会',
      },
      // 均等分摊示例
      averageExamples: {
        title: '📋 均等分摊说明',
        prepaidMode: '预付模式 + 均等分摊：\n• 每人预付相同金额\n• 创建者统一安排所有活动\n• 剩余资金平均退款或继续使用\n• 适用场景：公司团建、旅行团',
        actualExpenseMode: '实际费用 + 均等分摊：\n• 成员各自支付，上传收据\n• 总费用在所有人中平均分摊\n• 最终统一结算差额\n• 适用场景：临时活动、同事聚会',
      },
    },
    // 当前设置预览
    currentSettings: {
      title: '📋 当前设置',
      expenseMode: '分摊模式',
      shareMode: '按份分摊',
      currency: '货币',
      prepaidMode: '预付模式',
      actualExpenseMode: '实际费用模式',
      enabled: '已启用',
      averageMode: '均等分摊',
    },
  },

  // 费用统计
  statistics: {
    title: '旅行统计',
    loading: '正在计算统计数据...',
    // 概要统计
    summary: {
      totalSpent: '总支出',
      approvedAmount: '已审批金额',
      averageShare: '平均份额',
      averageSpent: '平均支出',
      budgetUsage: '预算使用率',
      expenseRecords: '费用记录',
      approvedReceipts: '已审批收据',
      budgetProgress: '预算使用情况',
      pending: '待审',
      rejected: '已拒绝',
      receipts: '张收据',
      groupMode: '团购模式：预付，平均分摊，简化管理',
    },
    // 类别统计
    categories: {
      title: '费用类别',
      transport: '交通',
      accommodation: '住宿',
      food: '餐饮',
      activities: '活动',
      shopping: '购物',
      documents: '证件',
      other: '其他',
    },
    // 成员统计
    members: {
      shareDetails: '成员份额详情',
      spentStats: '成员支出统计',
      participation: '成员参与度',
      shareAmount: '份额金额',
      difference: '差额',
      shouldReceive: '应收金额',
      shouldPay: '应付金额',
      remainingBalance: '剩余余额',
      needPayment: '需支付',
      balanced: '已平衡',
      unknownUser: '未知用户',
      totalSpent: '总支出',
      averagePerPerson: '每人平均',
      spent: '已支出',
      transactions: '笔交易',
    },
  },

  // 添加待办事项弹窗
  addTodoModal: {
    // 头部
    title: '添加待办事项',
    // 自定义添加
    customAdd: {
      title: '自定义添加',
      titleLabel: '标题',
      titlePlaceholder: '输入待办事项标题',
      descriptionLabel: '描述',
      descriptionPlaceholder: '输入详细描述（可选）',
      priorityLabel: '优先级',
    },
    // 优先级
    priority: {
      high: '高',
      medium: '中',
      low: '低',
    },
  },

  // 邀请好友页面
  inviteFriends: {
    header: {
      title: '邀请好友',
      subtitle: '邀请好友加入 "{{groupName}}"',
    },
    search: {
      placeholder: '搜索好友...',
    },
    sections: {
      available: '可邀请的好友',
      members: '已有成员',
      pending: '待处理的邀请',
    },
    status: {
      joined: '已加入项目',
      invitationSent: '邀请已发送，等待回复',
    },
    actions: {
      sendInvitations: '发送邀请',
      sending: '发送中...',
      continueInviting: '继续邀请',
      goBack: '返回',
    },
    loading: {
      text: '正在加载好友列表...',
    },
    empty: {
      noFriends: {
        title: '暂无好友',
        subtitle: '请先添加好友',
      },
      noResults: {
        title: '无搜索结果',
        subtitle: '尝试其他关键词',
      },
    },
    selection: {
      count: '已选择 {{count}} 名好友',
      sendCount: '发送邀请 ({{count}})',
    },
    alerts: {
      selectFriends: '请选择要邀请的好友',
      userInfoFailed: '获取用户信息失败',
      invitationSuccess: '邀请发送成功',
      invitationSuccessMessage: '已向 {{names}} 发送邀请',
      loadFriendsFailed: '加载好友列表失败',
      sendInvitationsFailed: '发送邀请失败',
      error: '错误',
      hint: '提示',
      unknownError: '未知错误',
      unknownUser: '未知用户',
    },
  },

  // 目的地数据
  destinations: {
    countries: {
      // 亚洲
      CN: 'China',
      HK: 'Hong Kong',
      MO: 'Macau',
      TW: 'Taiwan',
      JP: 'Japan',
      KR: 'South Korea',
      TH: 'Thailand',
      SG: 'Singapore',
      MY: 'Malaysia',
      VN: 'Vietnam',
      ID: 'Indonesia',
      IN: 'India',
      AE: 'United Arab Emirates',
      // 欧洲
      GB: 'United Kingdom',
      FR: 'France',
      DE: 'Germany',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'Netherlands',
      CH: 'Switzerland',
      // 北美
      US: 'United States',
      CA: 'Canada',
      // 大洋洲
      AU: 'Australia',
      NZ: 'New Zealand',
    },
    cities: {
      // 城市级目的地
      HongKong: '香港',
      Macau: '澳门',
      Singapore: '新加坡',
      // 中国城市
      Beijing: 'Beijing',
      Shanghai: 'Shanghai',
      Guangzhou: 'Guangzhou',
      Shenzhen: 'Shenzhen',
      Hangzhou: '杭州',
      Chengdu: '成都',
      Xian: '西安',
      Chongqing: '重庆',
      Wuhan: '武汉',
      Nanjing: '南京',
      // 台湾城市
      Taipei: 'Taipei',
      Kaohsiung: 'Kaohsiung',
      Taichung: 'Taichung',
      Tainan: 'Tainan',
      // 日本城市
      Tokyo: '东京',
      Osaka: '大阪',
      Kyoto: '京都',
      'JP-Kyoto': '京都',
      Nagoya: '名古屋',
      Fukuoka: '福冈',
      Sapporo: '札幌',
      // 韩国城市
      Seoul: 'Seoul',
      Busan: 'Busan',
      Daegu: 'Daegu',
      Incheon: 'Incheon',
      // 泰国城市
      Bangkok: 'Bangkok',
      ChiangMai: 'Chiang Mai',
      Phuket: 'Phuket',
      Pattaya: 'Pattaya',
      // 马来西亚城市
      KualaLumpur: 'Kuala Lumpur',
      Penang: 'Penang',
      Malacca: 'Malacca',
      JohorBahru: 'Johor Bahru',
      // 越南城市
      HoChiMinhCity: 'Ho Chi Minh City',
      Hanoi: 'Hanoi',
      DaNang: 'Da Nang',
      NhaTrang: 'Nha Trang',
      // 印尼城市
      Jakarta: 'Jakarta',
      Bali: 'Bali',
      Yogyakarta: 'Yogyakarta',
      Surabaya: 'Surabaya',
      // 印度城市
      NewDelhi: 'New Delhi',
      Mumbai: 'Mumbai',
      Bangalore: 'Bangalore',
      Kolkata: 'Kolkata',
      // 阿联酋城市
      Dubai: 'Dubai',
      AbuDhabi: 'Abu Dhabi',
      // 英国城市
      London: 'London',
      Edinburgh: 'Edinburgh',
      Manchester: 'Manchester',
      Liverpool: 'Liverpool',
      // 法国城市
      Paris: 'Paris',
      Lyon: 'Lyon',
      Marseille: 'Marseille',
      Nice: 'Nice',
      // 德国城市
      Berlin: 'Berlin',
      Munich: 'Munich',
      Hamburg: 'Hamburg',
      Frankfurt: 'Frankfurt',
      // 意大利城市
      Rome: 'Rome',
      Milan: 'Milan',
      Venice: 'Venice',
      Florence: 'Florence',
      // 西班牙城市
      Madrid: 'Madrid',
      Barcelona: 'Barcelona',
      Valencia: 'Valencia',
      Seville: 'Seville',
      // 荷兰城市
      Amsterdam: 'Amsterdam',
      Rotterdam: 'Rotterdam',
      TheHague: 'The Hague',
      // 瑞士城市
      Zurich: 'Zurich',
      Geneva: 'Geneva',
      Basel: 'Basel',
      // 美国城市
      NewYork: 'New York',
      LosAngeles: 'Los Angeles',
      Chicago: 'Chicago',
      SanFrancisco: 'San Francisco',
      LasVegas: 'Las Vegas',
      Miami: 'Miami',
      // 加拿大城市
      Toronto: 'Toronto',
      Vancouver: 'Vancouver',
      Montreal: 'Montreal',
      Ottawa: 'Ottawa',
      // 澳大利亚城市
      Sydney: 'Sydney',
      Melbourne: 'Melbourne',
      Brisbane: 'Brisbane',
      Perth: 'Perth',
      // 新西兰城市
      Auckland: 'Auckland',
      Wellington: 'Wellington',
      Christchurch: 'Christchurch',
    },
  },

  // 旅行聊天
  travelChat: {
    header: {
      title: '{{groupName}} 聊天室',
      subtitle: '旅行群聊',
    },
    loading: {
      text: '正在加载聊天记录...',
    },
    empty: {
      title: '暂无聊天记录',
      subtitle: '开始与您的团队成员聊天吧！',
    },
    input: {
      placeholder: '输入消息...',
    },
    time: {
      today: '今天',
      yesterday: '昨天',
    },
    errors: {
      sendFailed: '发送失败',
      networkError: '网络错误，请重试',
    },
    user: {
      unknown: '未知用户',
    },
  },

  // 费用管理
  expenseManagement: {
  fullAmount: '完整金额',
    ledgerTabs: {
      public: '群组账本',
      private: '成员私账',
    },
    // 统计
    statistics: {
      title: '费用统计',
      settings: '设置',
      consumed: '已消费',
      totalExpense: '总费用',
      approvedReceipts: '已审批收据',
      pendingReview: '待审',
      averagePerPerson: '人均',
      averagePerShare: '每份平均',
      categoryStatistics: '费用类别统计',
      shareMode: '按份分摊',
      averageMode: '均等分摊',
      perSharePayable: '每份应付',
      averageSplit: '均等分割',
    },
    // 收据
    receipts: {
      title: '收据',
      upload: '上传',
      exportPDF: 'PDF',
  exporting: '导出中...',
  confirmDelete: '确认删除',
  delete: '删除',
  deleteSuccess: '收据已删除',
  deleteFailed: '删除失败',
      approve: '审批',
      reject: '拒绝',
      confirmTitle: '确认操作',
      confirmApprove: '您确定要审批此收据吗？',
      confirmReject: '您确定要拒绝此收据吗？',
      cancel: '取消',
      confirm: '确认',
      approved: '收据已审批',
      rejected: '收据已拒绝',
      success: '操作成功',
      error: '操作失败',
      approveFailed: '审批失败',
      rejectFailed: '拒绝失败',
      operationFailed: '操作失败',
      imageUnavailable: '图片不可用',
      imageLoadError: '图片加载错误',
      cannotDisplay: '无法显示图片',
      emptyTitle: '暂无收据',
      emptySubtitle: '点击上传按钮开始添加收据',
    },
    privateReceipts: {
      modeInfo: '这是成员个人记录的私账，仅影响个人分账。',
      loading: '正在加载私账记录...',
      loadFailed: '加载私账记录失败',
      loadFailedHint: '请检查网络连接后重试。',
      retry: '重试',
      emptyTitle: '还没有私账记录',
      emptySubtitle: '成员上传自己的私账，或使用上方的“上传”按钮记录第一笔个人消费。',
      settlementTitle: '成员往来结算',
      settlementAmount: '{{payer}} 需向 {{receiver}} 支付 {{amount}}',
      settlementYouOwe: '你需要向 {{receiver}} 支付 {{amount}}',
      settlementOwesYou: '{{payer}} 需要向你支付 {{amount}}',
      settlementEmpty: '大家都结清啦，暂无成员之间的往来。',
      noPersonalSettlements: '你没有任何私人往来账。',
      noPersonalReceipts: '暂无与你相关的私账记录。',
      noPersonalReceiptsSubtitle: '其他成员之间的私账不会显示在这里。',
      youLabel: '你',
      vsSeparator: ' vs ',
    },
    privateMode: {
      info: '私账模式：这里上传的收据为个人私账，仅影响该成员的分摊。',
    },
    // 状态
    status: {
      pending: '待审',
      approved: '已审批',
      rejected: '已拒绝',
    },
    // 拒绝原因
    rejectionReason: {
      title: '拒绝原因',
    },
    // 拒绝输入
    rejectInput: {
      title: '拒绝收据',
      label: '请输入拒绝原因：',
      placeholder: '请详细说明拒绝此收据的原因...',
      cancel: '取消',
      confirm: '确认拒绝',
    },
    // 成员余额
    memberBalance: {
      title: '成员余额',
      paid: '已支付',
      shouldPay: '应付金额',
      overpaid: '超付',
      owes: '欠款',
      share: '份额',
    },
    // 支付模式
    paymentMode: {
      prepaid: '预付模式',
      actualExpense: '实际费用',
      shareMode: '按份模式',
      equalMode: '均等模式',
    },
    // 类别统计
    categoryStats: {
      title: '类别统计',
      total: '总计',
    },
    // 类别
    categories: {
      transport: '交通',
      accommodation: '住宿',
      food: '餐饮',
      flight: '航班',
      taxi: '出租车',
      attractions: '景点',
      shopping: '购物',
      entertainment: '娱乐',
      insurance: '保险',
      visa: '签证',
      communication: '通信',
      general: '其他',
    },
    // 导出
    export: {
      error: '导出失败',
      noData: '无数据可导出',
      success: '导出成功',
      successMessage: 'PDF报告已生成，可分享',
      failed: '导出失败，请重试',
    },
    // PDF报告翻译
    pdfReport: {
      title: '费用报告',
      subtitle: '财务详情与统计分析',
      generatedBy: 'PDF生成者',
      brandName: 'Cube Meet',
      brandWebsite: 'https://cubemeet.app',
      generatedAt: '生成于',
      brandFooter: '由 Cube Meet 提供支持 - 智能财务管理平台',
      brandSlogan: '智能生活，从费用追踪开始',
      // 部分标题
      sections: {
        overview: '财务概览',
        memberBalances: '成员余额详情',
        expenseDetails: '费用详情',
        receipts: '费用收据详情',
        categoryStats: '费用类别统计',
        categoryBreakdown: '类别明细',
      },
      // 概览项目
      overview: {
        totalExpense: '总费用',
        memberCount: '成员数',
        approvedReceipts: '已审批收据',
        pendingReceipts: '待审收据',
        memberUnit: '名拼客',
        receiptUnit: '张收据',
      },
      // 表格标题
      tableHeaders: {
        member: '拼客',
        spent: '已支出',
        shouldPay: '应付金额',
        balance: '余额',
        share: '份额',
        title: '标题',
        amount: '金额',
        category: '类别',
        date: '日期',
        uploader: '上传者',
        status: '状态',
        percentage: '百分比',
        unknown: '未知',
      },
      // 状态翻译
      status: {
        approved: '已审批',
        rejected: '已拒绝',
        pending: '待审',
        unknown: '未知',
      },
      // 余额状态
      balanceStatus: {
        overpaid: '超付',
        owed: '欠款',
      },
    },
  },

  // 旅行帖子详情
  travelPostDetail: {
    loading: '加载中...',
    emptyContent: '暂无内容',
    meta: {
      defaultTitle: '旅行笔记',
      siteName: '拼游 Cubemeet',
    },
    breadcrumbs: {
      home: '首页',
      city: '城市',
      guide: '指南',
    },
    messages: {
      cloneSuccess: '行程已复制，正在跳转...',
      cloneFailed: '复制行程失败，请稍后再试',
      postNotFound: '帖子不存在或已被删除',
      loadFailed: '加载帖子失败',
      followFailed: '关注失败',
      followed: '已关注',
      addedToItinerary: '已成功加入行程',
      noMapData: '暂无地图数据',
    },
    actions: {
      retry: '重试',
      back: '返回',
      backToTop: '回到顶部',
      cloneToItinerary: '复制为我的行程',
      viewMap: '地图模式',
    },
    error: {
      notFound: '帖子不存在',
    },
    cloneModal: {
      title: '复制为我的行程',
      labelTitle: '行程标题',
      placeholderTitle: '输入行程标题',
      labelStartDate: '出发日期',
      cancel: '取消',
      confirm: '确认复制',
      copyOf: 'Copy of',
    },
    postEngagement: {
      auth: {
        authenticated: '用户已认证',
        unauthenticated: '用户未认证',
        pleaseLogin: '请登录后发表评论',
        checkFailed: '认证检查失败',
      },
      comment: {
        anonymous: '匿名用户',
        empty: '评论内容为空',
        start: '开始发表评论',
        success: '评论发表成功',
        reload: '重新加载评论...',
        failed: '发表评论失败',
        unknownError: '未知错误',
        placeholder: '说点什么...',
        sending: '发送中...',
        send: '发送',
        total: '共 {{count}} 条评论',
        loading: '加载评论中...',
        loadMore: '加载更多评论',
        avatarError: '头像加载失败，使用默认头像',
        replyingTo: '回复 @ {{name}}',
      },
      time: {
        justNow: '刚刚',
        minsAgo: '{{count}}分钟前',
        hoursAgo: '{{count}}小时前',
        daysAgo: '{{count}}天前',
      },
      badge: {
        author: '作者',
        admin: '管理员',
        agency: '认证',
      },
      mention: {
        title: '提及用户',
        empty: '暂无用户可提及',
      },
      richContent: {
        imageLoadFailed: '图片加载失败:',
        imageAlt: '图片',
        empty: '暂无内容',
      },
    },
  },

  snapshot: {
      noContent: '暂无内容',
      imageLoadFailed: '图片加载失败',
      day: '第 {{number}} 天',
      openCardDetails: '打开卡片详情',
      openCardInNewWindow: '在新窗口打开卡片',
      prevImage: '上一张',
      nextImage: '下一张',
      openExternalLink: '打开链接',
      openExternalLinkTitle: '在新窗口打开链接',
      addToItinerary: '加入行程',
      addToItineraryTitle: '将此项目加入我的行程',
    },
};